<template>
  <div class="flex items-center h-full">
    <slot/>
    <div v-if="!hideLabels" class="break-words">
      <span v-if="!allOptionsLabel" v-for="(label, i) in labels" :key="label">
        {{ getLabel(label, i) }}
      </span>
      <span v-if="isEmpty(labels)">{{ labelEmpty }}</span>
      <span v-if="allOptionsLabel">{{ allOptionsLabel }}</span>
    </div>
  </div>
</template>

<script>
import BotIcon from '@/assets/images/icons/BotIcon'
import ChannelsIcon from '@/assets/images/icons/ChannelsIcon'
import isEmpty from 'ramda/src/isEmpty'

export default {
  name: 'FilterValue',
  components: { BotIcon, ChannelsIcon },

  props: {
    labels: {
      type: Array,
      required: true
    },
    labelEmpty: {
      type: String,
      default: ''
    },
    labelFull: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    hideLabels: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allOptionsLabel() {
      if (!this.labelFull) return null

      return this.options.length === this.labels.length ? this.labelFull : null
    }
  },
  methods: {
    isEmpty,
    getLabel(label, i) {
      return i === (this.labels.length - 1) ? label : `${label}, `
    }
  }
}
</script>
